import { Form, Input, Select } from 'antd';
import { useTranslation } from 'react-i18next';

import { NoMarginBottom } from './UserInfoDegreeSelector.styles';

import { Box } from '@/components/Utils';
import { RULES } from '@/constants';
import { useUniStudyBranchesOptions } from '@/hooks';
interface DegreeSelectProps {
  onChange?: (value: string) => void;
}
export const UserInfoDegreeSelector: React.FC<DegreeSelectProps> = ({ onChange }) => {
  const form = Form.useFormInstance();
  const selectedBranch = Form.useWatch('studyBranch', form);
  const { getDegreeOptions } = useUniStudyBranchesOptions();
  const selectedDegree = Form.useWatch('degree', form);
  const { t } = useTranslation('StudentOnboardingPageTranslations');
  const options = getDegreeOptions(selectedBranch, t('OTHER'));
  return (
    <Box flexDirection="column" gap={12}>
      <NoMarginBottom $isOther={selectedDegree === 'other'}>
        <Form.Item name="degree" rules={[RULES.REQUIRED]}>
          <Select
            options={options}
            placeholder={t('SELECT_DEGREE')}
            disabled={!selectedBranch}
            onChange={value => {
              form.setFieldValue('otherDegree', undefined);
              form.setFieldValue('university', undefined);
              form.setFieldValue('otherUniversity', undefined);
              onChange?.(value as string);
            }}
          />
        </Form.Item>
      </NoMarginBottom>
      {selectedDegree === 'other' && (
        <Form.Item
          rules={[
            RULES.REQUIRED,
            {
              validator: (_, value) => {
                if (selectedDegree === 'other' && !value) {
                  return Promise.reject(new Error(t('FIELD_REQUIRED')));
                }
                return Promise.resolve();
              }
            }
          ]}
          name="otherDegree">
          <Input placeholder={t('OTHER_DEGREE_PLACEHOLDER')} />
        </Form.Item>
      )}
    </Box>
  );
};
